module.exports = __webpack_public_path__ + "static/rocket-e5493eff16231b3d2d117e19a6510b41.png";